import { render } from "./ProjectComp.vue?vue&type=template&id=add06c16&scoped=true"
import script from "./ProjectComp.vue?vue&type=script&lang=js"
export * from "./ProjectComp.vue?vue&type=script&lang=js"

import "./ProjectComp.vue?vue&type=style&index=0&id=add06c16&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-add06c16"]])

export default __exports__